// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ytwjygdatwyyoxozqfat.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl0d2p5Z2RhdHd5eW94b3pxZmF0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU1MDIwMDcsImV4cCI6MjA2MTA3ODAwN30.OzeaLFCvg3EZgk9BdIqLapTnIgPAz0YpXo0bUtnxeB4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: localStorage
  }
});
